"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.Divider = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _MuiDivider = _interopRequireDefault(require("./MuiDivider"));
var _Wrapper = _interopRequireDefault(require("./Wrapper"));
var _excluded = ["marginBottom", "marginLeft", "marginRight", "marginTop", "mb", "ml", "mr", "mt", "height", "dashed", "light", "vertical", "className"];
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
var propTypes = process.env.NODE_ENV !== "production" ? {
  marginBottom: _propTypes["default"].string,
  // this prop is deprecated, use spacing props instead
  marginLeft: _propTypes["default"].string,
  // this prop is deprecated, use spacing props instead
  marginRight: _propTypes["default"].string,
  // this prop is deprecated, use spacing props instead
  marginTop: _propTypes["default"].string,
  // this prop is deprecated, use spacing props instead

  mb: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
  ml: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
  mr: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
  mt: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
  className: _propTypes["default"].string,
  light: _propTypes["default"].bool,
  vertical: _propTypes["default"].bool,
  dashed: _propTypes["default"].bool,
  height: _propTypes["default"].string
} : {};
var defaultProps = {
  dashed: false,
  light: false,
  vertical: false,
  height: '100%'
};
var Divider = exports.Divider = function Divider(_ref) {
  var marginBottom = _ref.marginBottom,
    marginLeft = _ref.marginLeft,
    marginRight = _ref.marginRight,
    marginTop = _ref.marginTop,
    mb = _ref.mb,
    ml = _ref.ml,
    mr = _ref.mr,
    mt = _ref.mt,
    height = _ref.height,
    dashed = _ref.dashed,
    light = _ref.light,
    vertical = _ref.vertical,
    className = _ref.className,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement(_Wrapper["default"], _extends({
    className: className,
    mb: mb || marginBottom,
    ml: ml || marginLeft,
    mr: mr || marginRight,
    mt: mt || marginTop,
    vertical: vertical
  }, rest), /*#__PURE__*/_react["default"].createElement(_MuiDivider["default"], {
    dashed: dashed,
    height: height,
    light: light,
    vertical: vertical
  }));
};
Divider.propTypes = process.env.NODE_ENV !== "production" ? propTypes : {};
Divider.defaultProps = defaultProps;
var _default = exports["default"] = Divider;